
import ctrlMixins from './_mixins.js';
// @ts-ignore
import { customTemplate, ctrlParamsForAll } from './_common-stuff.ts';
import { UarmCtrlComponentMeta } from '@uarmSrc/types';

/** Это наше кастомное поле, т.е. vue не использует их в конфигурации компонента */
const meta: UarmCtrlComponentMeta = {
	// это наши данные, т.е. вуй при объявлении компонента их не использует
	title: 'Выпадающий список',
	params: {
		isPublishType: {
			name: 'Статус публикации', // 1 - обычный четырехзначный, 2 - двузначный
			editType: 'publishTypeEditor',
		},
		customTemplate,
		defaultValue: {
			name: 'Значение по умолчанию',
			tip: 'Указывается ID нужной записи. Применяется только в карточке и только при создании записи',
			editType: 'input',
			onlyForViewTypes: ['card'],
		},
		groupUpdateData: {
			name: 'Пакетное обновление данных',
			editType: 'checkbox',
		},
		disableAllInFilter: {
			name: 'Не выводить "-- Все --" в фильтр (исп. с префильтрами)',
			editType: 'checkbox',
		},
		...ctrlParamsForAll,
	},
}

// Vue.extend нельзя! будут ошибки с $attrs и $listeners
export default {
	name: 'ctrl_dropdown',
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	meta,
	props: {
		// большая часть пропсов приезжает из ctrlMixins!
		/**
		 * Текущие выбранное значение
		 * @type {String|null}
		 */
		value: {
			default() {
				// параметр контрола defaultValue имеет более высокий приоритет
				// и применяется на более высоком уровне, тут речь только о ситуации когда ни значения ни defaultValue нет
				const c_ctrlParams = this.$props.field_meta.ctrlParams;
				return this.view_type === 'filter' && !c_ctrlParams.disableAllInFilter ? '' : null;
			},
		},
		/**
		 * Ключ для навзения поля в option.
		 * @type {string}
		 */
		label: {
			type: String,
			default: 'name',
		},
		/** Начальное значение */
		initial: {
			type: String,
			default: '',
		},
		/**
		 * Псевдо-placeholder
		 * Used in filter
		 * @type {string}
		 */
		placeholder: {
			type: String,
			default: '-- Выберите значение --',
		},
		/**
		 * Возвращяем только значение option, а не сам обьект.
		 * Значение ключа, которое будем возвращять.
		 * (плиз, не надо такими словами проперти называть, их невозможно по коду найти)
		 * @type {string}
		 */
		return: {
			type: String,
			default: 'id',
		},
		/**
		 * Максимальная высота в выпадающем списке.
		 * @deprecated
		 * @type {string}
		 */
		maxHeight: {
			type: String,
			default: '200px',
		},
	},
	data() {
		return {
			height: false,
			mutableLabel: '',
			mutableOptions: [],
			dropdownOpen: false,
		};
	},
	watch: {
		/**
		 * Когда изменлся props value
		 * меняем внутренний mutableValue.
		 * @param val
		 */
		value(val /* : any */) {
			this.mutableValue = val;

			if (this.return) {
				const initialValueWithReturn = this.return && this.mutableOptions.find((o) => o[this.return] === val);
				this.mutableValue = initialValueWithReturn || val;
			}

			this.setLabel(this.mutableValue);
		},
		/**
		 * Обновление списков
		 * @param  {mixed} val
		 * @returns {void}
		 */
		options(val) {
			this.mutableOptions = val;

			if (this.return) {
				const initialValueWithReturn = this.return && val.find((o) => o[this.return] === this.value);

				this.mutableValue = initialValueWithReturn || this.getLabel(this.value) || this.model;
				this.mutableLabel = this.getLabel(this.mutableValue);
			}
		},
	},
	computed: {
		isFilter() {
			return this.view_type === 'filter';
		},
		isRequired() {
			return !!this.field_meta.required;
		},
		isPublishType() {
			return this.field_meta.ctrlParams.isPublishType;
		},
		/**
		 * Выбранное значение в v-model
		 * @returns {object | string}
		 */
		model: {
			get() {
				return this.mutableValue;
			},
			set(v /* : IdName */) {
				if (this.return) {
					this.c_value = v[this.return];
					this.mixin_inputEvent({
						ctrlCode: this.$props.field_meta.ctrlCode,
						dbcolname: this.$props.field_meta.dbcolname,
						evtType: 'set',
						fullValue: {
							id: v.id,
							name: v.name,
							REVERT_VALUE_TO_PLAIN: true,
						},
					});
					this.mixin_saveEvent();
					return this.$emit('input', v[this.return]);
				}
			},
		},
		filteredOptions() {
			const search = (this.mutableLabel || '').toString().toLowerCase();

			return this.mutableOptions.filter((option) => {
				if (typeof option === 'object') {
					if (option.hasOwnProperty(this.label)) {
						return option[this.label].toString().toLowerCase().indexOf(search) > -1;
					} else {
						return console.warn(`[dropdown warn]: Label key "option.${this.label}"`);
					}
				}
				return option.toString().toLowerCase().indexOf(search) > -1;
			});
		},
	},
	created() {
		// TODO : Вынести данную логику за пределы дропдауна

		/** -- */
		if (this.isFilter && !this.c_ctrlParams.disableAllInFilter) this.mutableOptions.push({ id: '', name: '-- Все --' });
		if (!this.isRequired) this.mutableOptions.push({ id: null, name: '-- Не задано --' });
		// if (this.isRequired && this.is_new_record) this.mutableOptions.push({ id: null, name: '-- Выберите значение --' })

		if (this.isPublishType) {
			this.mutableOptions.push({ id: 4, name: 'Не опубликовано', color: '#aaa' });
			if (this.isPublishType !== 2) {
				this.mutableOptions.push({ id: 2, name: 'На внутреннем', color: '#4c9f9f' });
				this.mutableOptions.push({ id: 1, name: 'На внешнем', color: 'magenta' });
			}

			this.mutableOptions.push({ id: 3, name: 'Везде', color: 'black' });
		} else this.mutableOptions = [...this.mutableOptions, ...this.c_srv_options];

		/* -- */

		// Default value через MetaWiz записывается строкой.
		const initialValueWithReturn = this.return && this.mutableOptions.find((o) => o[this.return] == this.value);

		this.mutableValue = initialValueWithReturn || this.initial;
		this.mutableLabel = this.getLabel(this.mutableValue);
	},
	mounted() {
		// при создании записи для статусов публикации без явно заданного умолчательного значения ставим Опубликован
		if (this.$props.is_new_record && this.c_ctrlParams.isPublishType && !this.c_ctrlParams.defaultValue) {
			this.c_value = 3;
			this.$emit('input', 3);
		}
	},
	methods: {
		/**
		 * Изменяем видимость выпадающего списка
		 * Если кликнули в не области, закрываем.
		 * @param  {Event} e
		 * @returns {void}
		 */
		toggleDropdown(e) {
			let isClickOutside = e.target != this.$refs.dropdown && e.target != this.$refs.search && e.target != this.$el;
			isClickOutside && this._handleCloseDropdown();
		},
		/**
		 * @param  {Event} e
		 * @returns {void}
		 */
		_handleInputSearch(e) {
			this.mutableLabel = e.target.innerText.replace(/\xA0/, '').replace(/\s+/, ' ');
			this.$nextTick(() => {
				setCaret(this.$refs.search);
			});
		},
		/**
		 * @returns {void}
		 */
		_handleBlurSearch() {
			// TODO: need fixed. Bug click to lm-dropdown-icon. First event blur -> close -> after click icon open dropdown
			setTimeout(() => {
				this._handleCloseDropdown(); // Fix tabulate.
				this.mutableLabel = this.getLabel(this.mutableValue);
			}, 100);
		},
		/**
		 * Открываем выпадающий список.
		 * @param  {Event} e
		 * @returns {void}
		 */
		_handleOpenDropdown(e) {
			if (this.dropdownOpen || this.is_disabled) return;

			this.mutableLabel = '';
			this.dropdownOpen = true;
			setCaret(this.$refs.search);

			this.$nextTick(() => {
				this.container = document.querySelectorAll('body')[0];
				if (this.container) {
					this.container.addEventListener('click', this.toggleDropdown);
				}
			});
		},
		/**
		 * Закрываем выпадающий список
		 * @param  {Event} e
		 * @returns {void}
		 */
		_handleCloseDropdown() {
			this.dropdownOpen = false;
			this.container.removeEventListener('click', this.toggleDropdown, false);
		},
		/**
		 * Устанавливаем выбранный option.
		 * @param  {object | string} option
		 * @returns {void}
		 */
		select(option) {
			if (this.is_disabled) return;

			this.model = option;
			this.$refs.search.blur();
			this._handleCloseDropdown();
		},
		/**
		 * Проверяем, выбранн ли option.
		 * @param  {object | string} option
		 * @returns Boolean
		 */
		isOptionSelected(option) {
			return this.mutableValue === option;
		},
		setLabel(val) {
			this.mutableLabel = this.getLabel(val);
		},
		getLabel(option) {
			if (typeof option === 'object' && this.label && !!option[this.label]) {
				return option[this.label];
			} else {
				const label = this.mutableOptions.find((i) => i[this.return] === option);
				if (label) {
					return label[this.label];
				} else return option;
			}
		},
	},
};

function setCaret(el) {
	let range = document.createRange(),
		sel = window.getSelection(),
		lastKnownIndex = -1;

	for (let i = 0; i < el.childNodes.length; i++) {
		if (isTextNodeAndContentNoEmpty(el.childNodes[i])) {
			lastKnownIndex = i;
		}
	}

	if (lastKnownIndex === -1) return false;

	let row = el.childNodes[lastKnownIndex],
		col = row.textContent.length;

	range.setStart(row, col);
	range.collapse(true);
	sel.removeAllRanges();
	sel.addRange(range);

	el.focus();
}

function isTextNodeAndContentNoEmpty(node) {
	return node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0;
}
